<template>
  <div class="o-feed-section-empty">
    <h1>
      {{ title }}
    </h1>
    <p>
      {{ message }}
    </p>
    <MoleculeFeedSectionEmpty/>
  </div>
</template>

<script>
export default {
  name: 'OrganismFeedSectionEmpty',

  components: {
    MoleculeFeedSectionEmpty: () => import('@/components/molecules/MoleculeFeedSectionEmpty')
  },

  computed: {
    message () {
      return this.$route.name === 'projects'
        ? this.$t('oFeedSectionEmpty.message.projects')
        : this.$t('oFeedSectionEmpty.message.products')
    },

    title () {
      return this.$route.name === 'projects'
        ? this.$t('oFeedSectionEmpty.title.projects')
        : this.$t('oFeedSectionEmpty.title.products')
    }
  }
}
</script>
